import { api } from "./useApi";

export interface DoisFatoresStatus {
  ativo: boolean;
  ativado_em: string | null;
}

export interface DoisFatoresAtivacao {
  segredo: string;
  uri: string;
}

export const codigoErroDoisFatores = (error: any): string =>
  error?.response?.data?.error ?? "ERRO_INESPERADO";

export const mensagemErroDoisFatores = (codigo: string): string => {
  switch (codigo) {
    case "SENHA_INVALIDA":
      return "Senha incorreta.";
    case "2FA_CODIGO_INVALIDO":
      return "Código inválido. Confira o app e tente de novo.";
    case "2FA_ATIVACAO_EXPIRADA":
      return "O tempo para concluir a ativação acabou. Comece de novo.";
    case "2FA_JA_ATIVO":
      return "A autenticação em duas etapas já está ativa nesta conta.";
    case "2FA_NAO_ATIVO":
      return "A autenticação em duas etapas não está ativa nesta conta.";
    case "TOO_MANY_REQUESTS":
      return "Muitas tentativas. Aguarde alguns minutos e tente de novo.";
    default:
      return "Não foi possível concluir a operação. Tente novamente.";
  }
};

export const DoisFatoresApi = () => ({
  status: async (): Promise<DoisFatoresStatus> => {
    const response = await api.post("/usuario/2fa_status");
    return response.data;
  },

  iniciar: async (senha: string): Promise<DoisFatoresAtivacao> => {
    const response = await api.post("/usuario/2fa_iniciar", { senha });
    return response.data;
  },

  confirmar: async (codigo: string): Promise<{ ativo: boolean }> => {
    const response = await api.post("/usuario/2fa_confirmar", { codigo });
    return response.data;
  },

  desativar: async (senha: string, codigo: string): Promise<{ ativo: boolean }> => {
    const response = await api.post("/usuario/2fa_desativar", { senha, codigo });
    return response.data;
  },
});
